// extracted by mini-css-extract-plugin
module.exports = {"key":"style_key__RF_TI","value":"style_value__07DU7","submitButton":"style_submitButton__Tj2Wv"};